import { checkNoChosenYears } from 'portfolio3/features/pdf/utils/checkNoChosenYears';
import { checkSectionEmptiness } from 'portfolio3/features/pdf/utils/checkSectionEmptiness';
import { sortPeriods } from 'portfolio3/features/pdf/utils/sortPeriods';
import { createSelector } from 'reselect';
import { chosenYearsSelector } from 'selectors/drawers';
import { academicYearsTouchedSelector } from 'selectors/drawers/linkSharingDrawer';

import { civilClubsYearsSelector } from './civilClubsYearsSelector';
import { civilContestsYearsSelector } from './civilContestsYearsSelector';
import { civilRewardsYearsSelector } from './civilRewardsYearsSelector';
import { civilSectionsYearsSelector } from './civilSectionsYearsSelector';

export const civilSectionAcademicYearsDataSelector = createSelector(
  [
    // Данные раздела гражданская активность
    civilRewardsYearsSelector,
    civilClubsYearsSelector,
    civilContestsYearsSelector,
    civilSectionsYearsSelector,
    // Выбранные года
    chosenYearsSelector,
    academicYearsTouchedSelector,
  ],
  (civilRewardsYears, civilClubsYears, civilContestsYears, civilSectionsYears, chosenYears, academicYearsTouched) => {
    const emptyDataMap = {
      civil: true,
      civilReward: checkNoChosenYears(civilRewardsYears, chosenYears, academicYearsTouched),
      civilClub: checkNoChosenYears(civilClubsYears, chosenYears, academicYearsTouched),
      civilContest: checkNoChosenYears(civilContestsYears, chosenYears, academicYearsTouched),
      civilUnit: checkNoChosenYears(civilSectionsYears, chosenYears, academicYearsTouched),
    };

    emptyDataMap.civil = checkSectionEmptiness(emptyDataMap);

    const periods: Set<string> = new Set([
      ...civilRewardsYears,
      ...civilClubsYears,
      ...civilContestsYears,
      ...civilSectionsYears,
    ]);

    return {
      academicYears: sortPeriods(periods),
      emptyDataMap: {
        ...emptyDataMap,
        civil: checkSectionEmptiness(emptyDataMap),
      },
    };
  },
);
